import { useRequiredContext } from "@redotech/react-util/context";
import { Text } from "@redotech/redo-web/text";
import { useEffect, useRef } from "react";
import { TabNavigationContext } from "../tab-navigation-provider";
import * as styles from "./setting-section.module.css";

export function SettingSection({
  children,
  title,
  description,
  id,
}: {
  children?: React.ReactNode;
  title: string;
  description?: string;
  id: string;
}) {
  const { addSectionRef, removeSectionRef } =
    useRequiredContext(TabNavigationContext);

  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    addSectionRef(id, title, elementRef.current);

    return () => {
      removeSectionRef(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, title]);

  return (
    <div className={styles.container} id={id} ref={elementRef}>
      <div>
        <Text fontSize="xl" fontWeight="semibold" textColor="primary">
          {title}
        </Text>
        {description ? (
          <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
            {description}
          </Text>
        ) : undefined}
      </div>
      {children}
    </div>
  );
}
